import { u_, csl } from "@pressmedia/webappbase";
import moment from "moment";

export default {
	// 現在のページ
	currentPage: 1,
	
	/**
	 * サーバーから一覧データを取得後、IDごとの
	 * オブジェクトに整理してitemsに格納
	 * @param {Number} page: target page
	 * @param {Function} cb: callback function (@arg1: err, @arg2: responce)
	 * @returns {Promise}
	 */
	async loadItems(page, cb) {
		const methodName = "loadItems";
		
		const dataKey = this.getDataKey();
		if( !dataKey || !u_.isString(dataKey) ) {
			throw new Error("no dataKey.");
		}
		
		if( !u_.isNumber(page) ) {
			cb = page;
			page = false;
		}
		
		let endPoint = "";
		const reqData = this.parseFilter(this.getFilter);
		if(reqData.itemId && reqData.itemId.indexOf(":") < 0 && reqData.itemId !== "NULL") {
			endPoint = reqData.itemId;
			delete reqData.itemId;
		}
		
		!!page && Object.assign( reqData, this.getOffsetLimit(page) );
		
		// [send request]
		return this._sendRequest(methodName, {
			endPoint,
			data: reqData
		}, (err, res) => {
			if(!err) {
				if( !u_.hasProperty(res, "total") && u_.hasProperty(res, "count") ) {
					res.total = res.count;
				}
				if( !u_.hasProperty(res, "items") && u_.hasProperty(res, "list") ) {
					res.items = res.list;
				}
				
				u_.isNumber(res.total) || ( res.total = parseInt(res.total) );
				isNaN(res.total) && csl.warn("respones.total is NaN: ", res.total);
				this.items.length = res.total;
				
				if(this._itemGrouping(res) !== false) {
					if( u_.hasProperty(reqData, "offset") ) {
						res.offset = reqData.offset;
					}
					
					if( u_.hasProperty(reqData, "limit") ) {
						res.limit = reqData.limit;
					}
					
					// echo log.
					!!endPoint && (reqData.itemId = endPoint);
					csl.log.purple(`${dataKey}: item loaded.${!!page ? ` (page: ${page})` : ""}`, {
						items: this.items,
						filter: !!Object.keys(reqData).length ? reqData : "no filter."
					});
				}
			}
			
			return u_.isFunction(cb) && cb(err, res);
		});
	},
	
	/**
	 * 条件オブジェクトのパース
	 * @param {Array} conditions
	 * @returns {Object}
	 */
	_parseConditions(conditions) {
		const rtn = {};
		
		if( !Array.isArray(conditions) ) {
			return rtn;
		}
		
		conditions.forEach(cond => {
			if( !u_.isObject(cond) || !cond.targetParam || !u_.isString(cond.targetParam) ) {
				// continue
				return true;
			}
			
			let k, v;
			
			if(cond.targetParam === "KEYWORD") {
				if(cond.value || cond.value === 0) {
					k = "q";
					v = cond.value;
				}
			} else
			if(cond.targetParam === "OR" || cond.targetParam === "AND") {
				if( Array.isArray(cond.conditions) ) {
					const isOR = (cond.targetParam === "OR");
					
					// 再帰実行
					v = this._parseConditions(cond.conditions);
					
					k = Object.keys(v);
					if(k.length === 1) {
						v = v[k[0]];
						// OR ... {項目名}={比較演算子}:{値}|{比較演算子}:{値}
						// AND... {項目名}={比較演算子}:{値};{比較演算子}:{値}
						Array.isArray(v) && ( v = v.map(t => {
							return (t.indexOf(":") < 0) ? `eq:${t}` : t;
						}).join(isOR ? "|" : ";") );
						
						k = k[0];
						
					} else {
						// OR ={項目名}:{比較演算子}:{値}|{項目名}:{比較演算子}:{値}
						// AND={項目名}:{比較演算子}:{値};{項目名}:{比較演算子}:{値}
						v = Object.keys(v).map(pk => {
							if( Array.isArray(v[pk]) ) {
								v[pk] = v[pk].map(t => {
									return (t.indexOf(":") < 0) ? `eq:${t}` : t;
								}).join(isOR ? "|" : ";");
							} else
							if(v[pk].indexOf(":") < 0) {
								v[pk] = "eq:" + v[pk];
							}
							return (pk + ":" + v[pk]).replace(/^(OR|AND):/, "");
						}).join(isOR ? "|" : ";");
						
						!!v.length && (k = cond.targetParam);
					}
				}
			} else
			if( cond.condition && u_.isString(cond.condition) ) {
				k = cond.targetParam;
				
				if(cond.condition === "eq") {
					// 一致フィルタ（`{項目名}={値}`）
					v = (cond.value === undefined) ? "" : cond.value;
				} else {
					// 詳細なフィルタリング（`{項目名}={比較演算子}:{値}`）
					v = [
						cond.condition,
						(cond.value === undefined) ? "" : cond.value
					].join(":");
				}
			}
			
			if(k) {
				if( u_.hasProperty(rtn, k) ) {
					// 既に存在する場合は配列化
					Array.isArray(rtn[k]) || (rtn[k] = [rtn[k]]);
					rtn[k].push(v);
				} else {
					rtn[k] = v;
				}
			}
		});
		
		return rtn;
	},
	
	/**
	* フィルタオブジェクトのパース
	* @param {Object} fltr: filter object
	* @returns {Object}
	*/
	parseFilter(fltr) {
		if( !u_.isObject(fltr) ) {
			throw new TypeError("arguments[0] must be object. ");
		}
		
		const rtn = {};
		
		// [fields]
		if( Array.isArray(fltr.getParams) && fltr.getParams.length ) {
			rtn.fields = fltr.getParams.join(",");
		}
		
		if( Array.isArray(fltr.kickParams) && fltr.kickParams.length ) {
			!rtn.fields && (rtn.fields = "");
			rtn.fields += fltr.kickParams.map(pk => `-${pk}`).join(",");
		}
		
		// [condition]
		rtn._con_ = this._parseConditions(fltr.conditions);
		Object.keys(rtn._con_).forEach(pk => {
			// 重複していた場合はANDとみなす（{項目名}={比較演算子}:{値};{比較演算子}:{値}）
			Array.isArray(rtn._con_[pk]) && ( rtn._con_[pk] = rtn._con_[pk].map(t => {
				return (t.indexOf(":") < 0) ? `eq:${t}` : t;
			}).join(";") );
		});
		Object.assign(rtn, rtn._con_);
		delete rtn._con_;
		
		// [sort]
		if( u_.isObject(fltr.sort) && fltr.sort.sortKey && u_.isString(fltr.sort.sortKey) ) {
			rtn.sort = fltr.sort.sortKey;
			fltr.sort.isDesc && (rtn.sort = `-${rtn.sort}`);
			if( fltr.sort.sortFlags && u_.isString(fltr.sort.sortFlags) ) {
				rtn.sort = [fltr.sort.sortFlags, rtn.sort].join(":");
			}
		}
		
		return rtn;
	},
	
	/**
	 * currentPageとconfig.pageLimitからoffsetとlimitを算出して返す関数
	 * @param {Number} [currentPage]
	 * @returns {Object}
	 */
	getOffsetLimit(currentPage) {
		const rtn = {};
		
		if( u_.isNumber(currentPage) ) {
			this.currentPage = currentPage;
		}
		
		if( u_.isNumber(this.config.pageLimit) ) {
			if(this.currentPage > 1 && this.config.pageLimit > 0) {
				rtn.offset = this.config.pageLimit * (this.currentPage - 1);
			}
			rtn.limit = this.config.pageLimit;
		}
		
		return rtn;
	},
	
	/**
	 * サーバーから取得した一覧データの整理用関数
	 * ※loadItems内で使用
	 * @param {Object | Array} data
	 * @returns {Number} count
	 */
	_itemGrouping(data) {
		if( !u_.isObject(this.config.dataParams) ) {
			csl.warn("loadConfig is not executed yet.");
			return false;
		}
		
		const
			byId = {},
			byDate = {},
			formatYM = this.byDateFormat,	// default: "YYYY-MM",
			dp = this.config.dataParams;
			
		let list, byDateKey = this.pkGroupByDate;
		
		if( u_.isObject(data) && Array.isArray(data.items) ) {
			list = data.items;
		} else
		if( Array.isArray(data) ) {
			list = data;
		} else {
			throw new TypeError("arguments error.");
		}
		
		if(
			!byDateKey ||
			!u_.hasProperty(dp, byDateKey) ||
			["date", "datetime"].indexOf(dp[byDateKey].inpType) < 0
		) {
			byDateKey = "dateUpd";
		}
		
		for(let i = 0; i < list.length; i++) {
			const item = list[i];
			
			let is = u_.isObject(item);
			if(is) {
				// wysiwyg用データ中の{fileDir}をconfig.fileDirの値に置き換える
				this.wysiwyg.replaceFileDir.call(this, item);
				
				// コンストラクタで設定されたフィルタリング関数を実行
				is = (this.itemFilter.call(this, i, item, data) !== false);
			}
			
			if(!is) {
				list.splice(i, 1);
				i--;
				continue;
			}
			
			item.index = i;
			
			// idをキーとしたオブジェクトを作成
			if( u_.hasProperty(item, "itemId") && item.itemId ) {
				byId[ String(item.itemId) ] = list[i];
			}
			
			// byDateKeyごと
			const k = !!item[byDateKey] ? moment(item[byDateKey]).format(formatYM) : "0000-00";
			!byDate[k] && (byDate[k] = []);
			byDate[k].push(list[i]);
		}
		
		Object.assign(this.items, {
			list: list,
			byId: byId,
			byDate: byDate
		});
		
		return list.length;
	}
};
